import { Badge } from "react-bootstrap";

interface CategoryBadgeProps {
    cat: string
}

function CategoryBadge(props: CategoryBadgeProps) {
    return <Badge
        style={{ marginRight: 8 }}
        bg={props.cat === "project" ? "warning" : "secondary"}
        text={props.cat === "project" ? "dark" : "light"}>
        {props.cat}
    </Badge>;
}

export default CategoryBadge;